import { sha256 } from '@noble/hashes/sha2.js';

/** Local HTTP exposes getRandomValues, but not randomUUID or SubtleCrypto. */
export function randomUuid(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

const hex = (hash: Uint8Array): string => Array.from(hash, (byte) => byte.toString(16).padStart(2, '0')).join('');

/** Same digest over the original bytes; never suppress a native crypto failure. */
export async function sha256Hex(value: string | ArrayBuffer | Uint8Array<ArrayBuffer>): Promise<string> {
  const bytes = typeof value === 'string' ? new TextEncoder().encode(value)
    : value instanceof Uint8Array ? value : new Uint8Array(value);
  return hex(crypto.subtle ? new Uint8Array(await crypto.subtle.digest('SHA-256', bytes)) : sha256(bytes));
}

/** The SHA-256 of a text's UTF-8 bytes in lowercase hex, at once (no SubtleCrypto, so it also runs on local HTTP). */
export const sha256HexNow = (value: string): string => hex(sha256(new TextEncoder().encode(value)));
